import Title from "./Title";

function Thankyou({ message }) {
    return (
        <div className="fixed inset-24 flex items-center justify-center">
            <div className="text-xl font-inter text-[#4E5562]">
                <Title title={"Thank you"} />
                <div className="text-center pt-4 text-sm sm:text-lg sm:text-md lg:text-xl 2xl:text-2xl text-center">for submitting the form</div>
            </div>
        </div>
    );
}

export default Thankyou;